module.exports = __webpack_public_path__ + "static/media/ZIL.4cc9f8f0.svg";